import Check from '@material-ui/icons/Check';
import Close from '@material-ui/icons/Close';
import React from 'react';
import { Divider, Fixed, Flex, Modal, Text } from 'rebass';
import styled from 'styled-components';
import { PvBox, PvButton } from 'styles/CustomComponents';

const PvCheck = styled(Check)`
  color: ${props => props.theme.colors.green};
`;

const PvClose = styled(Close)`
  color: ${props => props.theme.colors.red};
`;

const WiderPvButton = styled(PvButton)`
  padding-top: ${props => props.theme.space[3]}px
  padding-bottom: ${props => props.theme.space[3]}px
  padding-left: ${props => props.theme.space[5]}px
  padding-right: ${props => props.theme.space[5]}px
`;

const MessageModal = ({messageType, message, hideModal}) => (
  <React.Fragment>
    <Fixed
      onClick={() => hideModal()}
      top={0}
      right={0}
      bottom={0}
      left={0}
    />
    <Modal width={['90%', '80%', '50vw']}>
      <Flex p={[3, 3, 4]} alignItems='center' justifyContent='center'>
        {!!messageType && messageType === 'ERROR' &&
        <PvBox mr={10}><PvClose style={{fontSize: '40px'}} /></PvBox>
        }
        {!!messageType && messageType === 'SUCCESS' &&
        <PvBox mr={10}><PvCheck style={{fontSize: '40px'}} /></PvBox>
        }
        {!!message &&
        <span>{message}</span>
        }
      </Flex>
      <Divider
        my={2}
        w={1}
        borderBottom={2}
        borderColor='grays.1'
      />
      <PvBox py={2}>
        <Text textAlign='center'>
          <WiderPvButton
            ml={2}
            onClick={() => hideModal()}>
            <span>OK</span>
          </WiderPvButton>
        </Text>
      </PvBox>
    </Modal>
  </React.Fragment>
);

export default MessageModal;


// WEBPACK FOOTER //
// ./src/components/modal/MessageModal.jsx